module.exports = __webpack_public_path__ + "static/img/indexBg2.319bf93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexBg2.png
// module id = 0fI+
// module chunks = 18